import { toObject } from "../../core/utils";
import constants from "../../core/constants";

class VariablePlanPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    data.fuel_compensation /= constants.currencyBy;
    data.maintenance_compensation /= constants.currencyBy;

    return toObject(data);
  }
}

export default VariablePlanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/variablePlan/variablePlan.transforms.js